import TableDynamic from "../../components/TableDynamic";
import React from "react";
import { Dropdown } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { store } from "../../reducer/Store";
import ApiService from "../../services/ApiService";
import ModalFormRegisterOrUpdate from "../../components/ModalFormRegisterOrUpdate";
const CommunicationTools = () => {
  const { dispatch, state } = React.useContext(store);
  const [showUpdateCom, setShowUpdateCom] = React.useState(false);
  const [showAddCom, setShowAddCom] = React.useState(false);
  const [comToolName, setComToolName] = React.useState("");
  const [comToolId, setComToolId] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState("");
  const columnsName = ["Outils de communication", ""];
  const columns = ["name", "updateAndDelete"];

  const handleClose = () => {
    setShowUpdateCom(false);
    setShowAddCom(false);
    setComToolName("");
    setComToolId("");
    setErrorMessage("");
  };

  const handleUpdateCom = (com) => {
    setComToolName(com.name);
    setComToolId(com.id);
    setShowUpdateCom(true);
  };

  const handleShowAddCom = () => setShowAddCom(true);

  /**
   * Cette fonction récupère la liste des outils de communication à partir de l'API et la stocke dans le state de l'application.
   * @returns {void}
   */
  const getComTools = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-com-tool-types-by-year/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTCOMTOOLS",
          payload: response.data,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Fonction asynchrone pour ajouter un outil de communication..
   * Cette fonction envoie une requête API pour créer un nouvel outil de communication en utilisant les informations fournies.
   * Elle utilise le hook useState pour mettre à jour l'état du loader en cours d'exécution et afficher un message d'erreur si la création échoue.
   * Si le nom existe déjà, elle affiche un message d'erreur approprié.
   * @param { Number } year_id - L'année à laquelle rattacher l'outil de communication.
   * @param { String } name - Nom de l'outil de communication.
   * @returns {void}
   */
  const registerComTool = async () => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      { name: comToolName, year_id: state.currentYear.value },
      "operation-com-tool-types",
      "post"
    )
      .then(function () {
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getComTools();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà.");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour l'outil de communication sélectionné par l'utilisateur avec le nom et l'année spécifiés.
   * Elle effectue une requête HTTP PUT à l'aide de l'API Service en passant les informations nécessaires dans la requête.
   * Si la requête réussit, elle ferme la fenêtre modale, désactive le chargement et appelle la fonction "getComTools" pour mettre à jour la liste des outils de communication.
   * Si la requête échoue, elle désactive le chargement et vérifie le type d'erreur. Si le message d'erreur indique que le nom existe déjà, elle définit un message d'erreur. Si le message d'erreur indique que l'utilisateur n'est pas authentifié, elle supprime le token de l'utilisateur de local storage et appelle la fonction "SET_LOGOUT" pour déconnecter l'utilisateur.
   * @param { Number } year_id - L'année à laquelle rattacher l'outil de communication.
   * @param { String } name - Nom de l'outil de communication.
   * @param { Number } comToolId - L'ID de l'outil de communication.
   */
  const updateComTool = async () => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      { name: comToolName, year_id: state.currentYear.value },
      "operation-com-tool-types/" + comToolId,
      "put"
    )
      .then(function () {
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getComTools();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà.");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };
  /**
   * Cette fonction supprime un outil de communication en envoyant une requête à l'API.
   * Elle affiche également une confirmation à l'utilisateur avant de procéder à la suppression.
   * @param { Object } comTool - L'objet comTool à supprimer.
   */
  const deleteComTool = async (comTool) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer l'outil de communication " +
          comTool.name +
          "?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "operation-com-tool-types/" + comTool.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getComTools();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };
  React.useEffect(() => {
    getComTools();
  }, [state.currentYear]);

  return (
    <>
      <h1>
        Outils de communication
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleShowAddCom}>
              Ajouter un outil
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>

      {showAddCom && (
        <ModalFormRegisterOrUpdate
          show={showAddCom}
          registerOrUpdate={registerComTool}
          name={comToolName}
          setName={setComToolName}
          errorMessage={errorMessage}
          handleClose={handleClose}
          controlFormId={"add-communication-comtool"}
        />
      )}

      {showUpdateCom && (
        <ModalFormRegisterOrUpdate
          show={showUpdateCom}
          errorMessage={errorMessage}
          registerOrUpdate={updateComTool}
          name={comToolName}
          setName={setComToolName}
          handleClose={handleClose}
          controlFormId={"update-communication-comtool"}
        />
      )}
      <TableDynamic
        deleteD={deleteComTool}
        showUpdate={handleUpdateCom}
        columnsName={columnsName}
        columns={columns}
        data={state.listComTools}
      ></TableDynamic>
    </>
  );
};

export default CommunicationTools;
